import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import {fetchDataDetailHistory, getTableHistoryConfig} from "../service";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class InventoryPageDetailHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataTable: [],
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
            },
        }
    }

    componentDidMount() {
        fetchDataDetailHistory(this.props.type, this.setState.bind(this), this.props.selectedData, this.props.setError);
    }

     handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        const dynamicTableConfig = getTableHistoryConfig(this.props.type);
        return (
            <SimpleModal
                title={this.props.pageConfig.detail.detailHistory.pageTitle}
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <div className="grid grid-2x grid-mobile-none gap-20px margin-bottom-20px">
                            <div id="grid-1">
                                {
                                    this.props.pageConfig.detail.detailHistory.firstGrid.map(
                                        (field) => (
                                            <SimpleInput
                                                key={field.name}
                                                id={`input_text_${field.name}`}
                                                name={field.name}
                                                label={field.label}
                                                readOnly={true}
                                                value={this.props.selectedData[field.name]}
                                            />
                                        )
                                    )
                                }
                            </div>

                            <div id="grid-2">
                                <SimpleInput
                                    id="input_text_qrCode"
                                    name="qrCode"
                                    label="QR Code"
                                    readOnly={true}
                                    value={this.props.selectedData.qrCode}
                                />
                            </div>
                        </div>
                        <SimpleDataTable
                            key={`${this.state.pagination.count}-${this.state.pagination.page}`}
                            data={this.state.dataTable}
                            columns={dynamicTableConfig}
                            rowsPerPage={this.state.pagination.limit}
                            toCount={this.state.pagination?.count}
                            page={this.state.pagination.page - 1}
                            options={{
                                ...defaultTableChange( this.handleChangePage, this.handleRowsPerPage ),
                                serverSide: false,
                            }}
                        />
                        <div style={{textAlign: "right", marginTop: "10px"}}>
                            <SimpleButton
                                onClick={() => this.props.onClickClose()}
                                secondary
                                text={"Kembali"}
                            />
                        </div>
                    </ModalContainer>
                }
            />
        )
    }
}

export default InventoryPageDetailHistory;